export enum SebastianStatus {
  Error = 'error',
  Loading = 'loading',
  Ready = 'ready'
}
